import axiosInstance from './axiosInstance';

export const getQuestions = () => axiosInstance.get('/Quiz/GetQuestions');
export const submitQuiz = (answers) => axiosInstance.post('/Quiz/Submit', { answers });
export const getMyStatus = () => axiosInstance.get('/Quiz/MyStatus');

// Admin CRUD — question bank management
export const adminGetQuestions = () => axiosInstance.get('/Quiz/AdminGetQuestions');
export const adminCreateQuestion = (body) => axiosInstance.post('/Quiz/AdminCreateQuestion', body);
export const adminUpdateQuestion = (body) => axiosInstance.put('/Quiz/AdminUpdateQuestion', body);
export const adminDeleteQuestion = (id) => axiosInstance.delete(`/Quiz/AdminDeleteQuestion/${id}`);

// Admin — a given user's quiz status ({ passed, bestScore, attempts }), used
// on the admin user-edit page (task B10).
export const adminUserStatus = (userId) => axiosInstance.get(`/Quiz/AdminUserStatus/${userId}`);
